import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { getUserProfile, getAffirmation, logoutUser } from "../api";

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);  // ✅ Define user state
  const [affirmation, setAffirmation] = useState("");  // ✅ Define affirmation state
  const [selectedSign, setSelectedSign] = useState("");
  console.log("🐾 User profile:", user);
  console.log("🔮 Affirmation:", affirmation);
  console.log("🚀 Dashboard component mounted");
  console.log("🔄 useEffect triggered");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        console.log("📡 Fetching user profile...");
        const profile = await getUserProfile();
        setUser(profile);
  
        if (profile.zodiac_sign && profile.zodiac_sign !== "Unknown") {
          console.log(`🌟 User's zodiac sign: ${profile.zodiac_sign}`);
          const affirmationData = await getAffirmation(profile.zodiac_sign);
          setAffirmation(affirmationData.message);
        } else {
          console.warn("⚠️ No valid zodiac sign, skipping affirmation.");
        }
      } catch (error) {
        if (error.response?.status === 403) {
          console.warn("🚪 Session expired or unauthorized — redirecting to login.");
          navigate("/login");
        } else {
          console.error("❌ Non-auth error fetching user profile:", error);
          // Optional: show fallback UI, alert, or just stay on the dashboard
        }
      }
    };
  
    fetchUserProfile();
  }, [navigate]);

  const handleLogout = async () => {
    await logoutUser();
    navigate("/login");
  };

  if (!user) {
    return <div className="text-white p-6">Loading...</div>;
  }

  const handleSelectZodiac = async (selectedSign) => {
    if (typeof selectedSign !== "string") {
      console.warn("⚠️ Invalid type for zodiac sign:", selectedSign);
      return;
    }
  
    const zodiacMap = {
      Aries: "Aries",
      Taurus: "Taurus",
      Gemini: "Gemini",
      Cancer: "Cancer",
      Leo: "Leo",
      Virgo: "Virgo",
      Libra: "Libra",
      Scorpio: "Scorpio",
      Sagittarius: "Sagittarius",
      Capricorn: "Capricorn",
      Aquarius: "Aquarius",
      Pisces: "Pisces",
    };
  
    const hardcodedSign = zodiacMap[selectedSign];
  
    if (!hardcodedSign) {
      console.warn("⚠️ Potential tampering or invalid selection:", selectedSign);
      return;
    }
  
    try {
      console.log("🛠 Sending hardcoded zodiac sign:", hardcodedSign);
      const csrfToken = getCookie("csrftoken");
  
      const response = await api.put(
        "/userprofile/",
        { zodiac_sign: hardcodedSign },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      console.log("✅ Zodiac updated successfully:", response.data);
  
      setUser((prevUser) => ({
        ...prevUser,
        zodiac_sign: hardcodedSign,
      }));
  
      const affirmationData = await getAffirmation(hardcodedSign);
      setAffirmation(affirmationData.message);
    } catch (error) {
      console.error("❌ Failed to update zodiac sign:", error);
    }
  };
  

  return (
    <div className="min-h-screen bg-heroBg flex items-center justify-center px-4 py-12 text-white">
      <div className="glass backdrop-blur-lg border border-gold rounded-3xl shadow-xl max-w-4xl w-full px-8 py-12 relative bg-white/2">
  
        <button
          onClick={handleLogout}
          className="absolute top-6 right-6 px-4 py-2 text-sm font-semibold bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md transition duration-300"
        >
          Logout
        </button>
  
        {!user?.zodiac_sign || user?.zodiac_sign === "Unknown" || user?.zodiac_sign === "Not Set" || user?.zodiac_sign === "" ? (
          <>
            <h2 className="text-2xl text-gold mb-6">Select Your Star Sign ✨</h2>
            <select
             defaultValue=""
             onChange={(e) => handleSelectZodiac(e.target.value)}
             className="p-3 rounded-lg border border-gold text-[#041c16] bg-white/80"
            >
             <option value="" disabled>-- Choose your Sign --</option>
             <option value="Aries">Aries</option>
             <option value="Taurus">Taurus</option>
             <option value="Gemini">Gemini</option>
             <option value="Cancer">Cancer</option>
             <option value="Leo">Leo</option>
             <option value="Virgo">Virgo</option>
             <option value="Libra">Libra</option>
             <option value="Scorpio">Scorpio</option>
             <option value="Sagittarius">Sagittarius</option>
             <option value="Capricorn">Capricorn</option>
             <option value="Aquarius">Aquarius</option>
             <option value="Pisces">Pisces</option>
            </select>
          </>
        ) : (
          <>
            <h1 className="text-5xl font-extrabold tracking-wide text-[#041c16] mb-6">
              Welcome, {user?.name || user?.username || user?.email || "Explorer"} ✦
            </h1>
  
            <p className="text-xl text-[#041c16] mb-4">
              🌙 Zodiac Sign:{" "}
              <span className="font-semibold">{user?.zodiac_sign || "Not Set"}</span>
            </p>
  
            {affirmation ? (
              <div className="mt-6 mx-auto max-w-2xl bg-white/10 text-[#041c16] border border-gold px-8 py-6 rounded-xl backdrop-blur-md">
                <p className="text-lg italic leading-relaxed">
                  “{affirmation}”
                </p>
              </div>
            ) : (
              <p className="text-[#041c16] text-lg opacity-70 mt-6">
                🌠 Waiting for your cosmic insight...
              </p>
            )}
          </>
        )}
      </div>
    </div>
  )
};

export default Dashboard;
